import { useState, useEffect } from 'react';
import { getDefaultProjectData, getDoDsByDiscipline } from '../../../../utils/DefaultProjectData';

export function useDisciplines(supabase, user) {
  const [disciplines, setDisciplines] = useState([]);
  const [doDsByDiscipline, setDoDsByDiscipline] = useState({});

  useEffect(() => {
    async function loadDisciplines() {
      if (!supabase || !user?.proj?.id) return;

      const projectType = user.proj.type;
      if (!projectType) {
        setDisciplines([]);
        setDoDsByDiscipline({});
        return;
      }

      const defaultDisciplines = getDefaultProjectData(projectType);

      const { data: setting } = await supabase
        .from("settings")
        .select("value")
        .eq("project_id", user.proj.id)
        .eq("name", "project_disciplines")
        .maybeSingle();

      let mergedDisciplines = [];
      if (setting?.value) {
        try {
          const customDisciplines = JSON.parse(setting.value);
          // If custom disciplines exist, use them directly (they represent the current state after deletions)
          // Only merge with defaults for missing properties, but don't add back deleted defaults
          const defaultMap = new Map(defaultDisciplines.map(d => [d.id, d]));
          
          // Merge custom disciplines with defaults, preserving custom DoDs if they exist
          mergedDisciplines = customDisciplines.map(customDiscipline => {
            const defaultDiscipline = defaultMap.get(customDiscipline.id);
            if (defaultDiscipline) {
              return {
                ...defaultDiscipline,
                ...customDiscipline,
                // Use custom doDs if they exist, otherwise use defaults
                doDs: customDiscipline.doDs && customDiscipline.doDs.length > 0
                  ? customDiscipline.doDs
                  : (defaultDiscipline.doDs || []),
                // Preserve excludeFromDoDs property, default to false if not set
                excludeFromDoDs: customDiscipline.excludeFromDoDs === true
              };
            }
            return {
              ...customDiscipline,
              excludeFromDoDs: customDiscipline.excludeFromDoDs === true
            };
          });
          
          // Don't add back default disciplines that were removed - custom list is the source of truth
          
          mergedDisciplines.sort((a, b) => (a.order || 0) - (b.order || 0));
        } catch (e) {
          console.error("Failed to parse project_disciplines setting:", e);
          mergedDisciplines = defaultDisciplines;
        }
      } else {
        mergedDisciplines = defaultDisciplines;
      }

      setDisciplines(mergedDisciplines);
      
      // Group DoDs by discipline
      const grouped = getDoDsByDiscipline(mergedDisciplines);
      setDoDsByDiscipline(grouped);
    }
    loadDisciplines();
  }, [supabase, user]);

  return { disciplines, doDsByDiscipline };
}

